var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 12.8418C10.0093 12.8418 10.8281 13.6606 10.8281 14.6709C10.828 15.6811 10.0092 16.5 8.99902 16.5C7.98888 16.4999 7.17002 15.681 7.16992 14.6709C7.16992 13.6607 7.98882 12.8419 8.99902 12.8418ZM8.99902 7.1709C10.0093 7.1709 10.8281 7.98972 10.8281 9C10.8281 10.0103 10.0093 10.8291 8.99902 10.8291C7.98883 10.829 7.16993 10.0102 7.16992 9C7.16992 7.98978 7.98882 7.17099 8.99902 7.1709ZM8.99902 1.5C10.0092 1.5 10.828 2.3189 10.8281 3.3291C10.8281 4.33938 10.0093 5.1582 8.99902 5.1582C7.98882 5.15811 7.16992 4.33932 7.16992 3.3291C7.17001 2.31896 7.98888 1.50009 8.99902 1.5Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic-more.6ad905a9f9b76f5638e36bce7279dff3.svg";
export { ForwardRef as ReactComponent };